import React, { forwardRef, ForwardRefRenderFunction } from "react";
import { generatorIframeID } from "../token-renderer-utilities";

const GeneratorIframe: ForwardRefRenderFunction<
  HTMLIFrameElement,
  Record<string, unknown>
> = (_, ref) => {
  return (
    <div>
      <iframe id={generatorIframeID} ref={ref} />
    </div>
  );
};

export default forwardRef<HTMLIFrameElement, Record<string, unknown>>(
  GeneratorIframe
);
